import { useOidc } from '@axa-fr/react-oidc';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '#pie/components/text/Text';
import { VITE_MOCK_IDP } from '#pie/env';
import { ErrorPage } from '../error-page/ErrorPage';

export const AuthError = () => {
  const oidc = useOidc();
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URL(document.location.toString()).searchParams;

    if (params.get('eh') === 'true') {
      oidc.login('/', { prompt: 'login' });
    }
  }, [oidc.login]);

  return (
    <ErrorPage
      heading={t('auth_error.title')}
      message={
        <>
          {t('auth_error.message')}
          {VITE_MOCK_IDP && process.env.NODE_ENV === 'development' && (
            <>
              <Text>
                <code>VITE_MOCK_IDP</code> is <code>true</code>, so mock IDP
                server should be running.
              </Text>
              <Text>
                Did you run <code>nx dev mock-idp</code>?
              </Text>
            </>
          )}
        </>
      }
    />
  );
};
